import React from 'react';
import { Link } from 'atomic-router-react';
import { useUnit } from 'effector-react';
import { useT } from 'src/i18n';
import { $locale, localeRoutes } from 'src/models/locale';
import { Ellipse2 } from 'src/ui/svg/SVGs';

import './Experience.scss';

export const Experience = () => {
  const t = useT();
  const locale = useUnit($locale);
  const projectsRouteForLocale = localeRoutes[locale].projects;

  return (
    <div className="experience-block">
      {t.experience.jobs.map((job) => (
        <div className="experience-block__job" key={job.company}>
          <p className="paragraph paragraph_experience paragraph_job">
            <span>{job.company}</span>
            {' — '}
            {job.role}
          </p>
          <p className="experience-block__period">
            {job.period}
            {' · '}
            {job.duration}
          </p>
          <p className="experience-block__highlights">{job.highlights}</p>
        </div>
      ))}

      <Link to={projectsRouteForLocale} className="experience-block__link">
        {t.experience.projectsLink}
      </Link>
      <Ellipse2 />
    </div>
  );
};
